import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_invoice_total_units_with_filters_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId?: number, projectId?: number, statusIds?: number[], createdFrom?: string, createdTo?: string }): 
  Promise<{ result: { TotalUnits?: number } }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_invoice_total_units_with_filters_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId?: number, projectId?: number, statusIds?: number[], createdFrom?: string, createdTo?: string    }) {
      return false;
    }
}
